import { EnvironmentOptions } from "environments/environment_options";

export const environment: EnvironmentOptions = {
	production: true,
	baseURL: 'https://api.prenota.saluteconte.it/api',
	oauthNode: 'oauth',
	webSocketURI: (() =>  {
		let websocketUri;
		if (window.location.protocol === "https:") {
			websocketUri = "wss:";
		} else {
			websocketUri = "ws:";
		}
		websocketUri += `//api.${window.location.host}/api`;
		return websocketUri;
	})()
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts